// Calendar state, managing the building of a calendar
// (days) and the sessions on that cal

import * as _ from 'underscore';
import { combineReducers } from 'redux';
import ACTIONS from './actions';

const librarySessionsTree = (state = [], action) => {
    let newState = [];
    switch (action.type) {
        case ACTIONS.LIBRARY_SESSIONS_LOAD:
            newState = [...action.sessions];
            newState.map(session => {
                session.key = session.id;
            });
            return _.sortBy(newState, 'title');
        case ACTIONS.LIBRARY_SESSION_ADD:
            const newSession = {
                ...action.session,
                id: parseInt(action.session.id),
                key: parseInt(action.session.id),
                eType: 'w',
                label: action.session.title,
                typeElement: 'session'
            };
            newState = [...state, newSession];
            return _.sortBy(newState, 'title');
        case ACTIONS.UI_RELOAD_DRAWER:
            return [];
        default:
            return state;
    }
};

const fixedLengthProgramsTree = (state = [], action) => {
    let newState = [];
    switch (action.type) {
        case ACTIONS.FIXED_PROGRAMS_LOAD:
            newState = [...action.programs];
            newState.map(program => {
                program.key = program.id;
            });
            return _.sortBy(newState, 'title');
        case ACTIONS.FIXED_PROGRAMS_ADD:
            const newProgram = {
                ...action.program,
                typeElement: 'program'
            };
            newState = [...state];
            newState.push(newProgram);
            return _.sortBy(newState, 'title');
        case ACTIONS.UI_RELOAD_DRAWER:
            return [];
        default:
            return state;
    }
};

const calendarProgramsTree = (state = [], action) => {
    let newState = [];
    switch (action.type) {
        case ACTIONS.CALENDAR_PROGRAMS_LOAD:
            newState = [...action.calendars];
            let subCount = 1;
            newState.map(calendar => {
                calendar.key = calendar.id;
                if (calendar.subscribed) {
                    calendar.subCount = subCount;
                    subCount++;
                }
            });
            return _.sortBy(newState, 'title');
        case ACTIONS.CALENDAR_PROGRAMS_ADD:
            newState = [...state, ...action.teams];
            return _.sortBy(newState, 'title');
        case ACTIONS.CALENDAR_PROGRAMS_UNSUBSCRIBE:
            newState = [...state];
            newState = newState.map(cal => {
                const _cal = {
                    ...cal,
                    subCount: calculateSubcount(
                        cal.subCount,
                        action.calendar.subCount
                    )
                };
                if (_cal.id === action.calendar.id) {
                    _cal.subscribed = false;
                    _cal.subCount = null;
                }
                return _cal;
            });
            return _.sortBy(newState, 'title');
        case ACTIONS.CALENDAR_PROGRAMS_SUBSCRIBE:
            newState = [...state];
            let subCounts = newState.map(cal => cal.subCount);
            subCounts = subCounts.filter(c => typeof c === 'number');
            const subCountMax = subCounts.sort()[subCounts.length - 1];
            const calKey = _.findKey(newState, { id: action.calendar.id });
            newState[calKey] = {
                ...action.calendar,
                subCount: calculateSubcount(subCountMax, null, true),
                subscribed: true
            };
            return _.sortBy(newState, 'title');
        case ACTIONS.UI_RELOAD_DRAWER:
        case ACTIONS.CALENDAR_PROGRAM_CLEAR:
            return [];
        default:
            return state;
    }
};

let rawExerciseCount = 0;
// after selecting a single exercise only these
export const exerciseRef = (state = [], action = {}) => {
    let newState = [];
    switch (action.type) {
        case ACTIONS.EXERCISES_LOAD:
            if (
                action.exercises.length === rawExerciseCount &&
                state.length > 0
            ) {
                return state;
            }

            rawExerciseCount = action.exercises.length;
            for (var i = 0; i < action.exercises.length; i++) {
                const exercise = action.exercises[i];
                if (exercise.eType === 'e') {
                    newState.push({
                        ...exercise,
                        value: exercise.id,
                        label: exercise.title
                    });
                }
            }

            newState.options = _.sortBy(newState, option => -option.use_count);
            return newState;
        case ACTIONS.EXERCISES_REF_ADD:
            newState = [...state];
            newState.push({
                ...action.exercise,
                value: action.exercise.id,
                label: action.exercise.title
            });

            newState.options = _.sortBy(newState, 'stitle');
            return newState;
        case ACTIONS.EXERCISE_UPDATE:
            newState = [...state];
            const exeIndex = _.findKey(newState, { id: action.exercise.id });
            if (exeIndex) {
                newState[exeIndex] = action.exercise;
            }
            newState.options = [...newState];
            return newState;
        case ACTIONS.EXERCISES_TH_CLEAR:
            const allExercises = [...state];
            for (let i = 0; i < allExercises.length; i++) {
                if (allExercises[i].user_id !== 0) {
                    newState.push(allExercises[i]);
                }
            }
            return newState;
        default:
            return state;
    }
};

// after selected circuit option, only these
export const exerciseBenchmarkRef = (state = {}, action = {}) => {
    let newState = {};
    switch (action.type) {
        case ACTIONS.EXERCISES_LOAD:
            if (
                action.exercises.length === rawExerciseCount &&
                state.length > 0
            ) {
                return state;
            }
            rawExerciseCount = action.exercises.length;
            newState = [];
            for (let i = 0; i < action.exercises.length; i++) {
                const exercise = action.exercises[i];
                if (exercise.eType === 'wc') {
                    newState.push({
                        ...exercise,
                        value: exercise.id,
                        label: exercise.title
                    });
                }
            }
            newState.options = _.sortBy(newState, option => -option.use_count);
            return newState;
        case ACTIONS.EXERCISES_BENCHMARK_REF_ADD:
            newState = [...state];
            newState.push({
                ...action.exercise,
                value: action.exercise.id,
                label: action.exercise.title
            });
            newState.options = _.sortBy(newState, 'stitle');
            return newState;
        case ACTIONS.EXERCISE_UPDATE:
            newState = [...state];
            const exeIndex = _.findKey(newState, { id: action.exercise.id });
            if (exeIndex) {
                newState[exeIndex] = action.exercise;
            }
            newState.options = [...newState];
            return newState;
        default:
            return state;
    }
};

// for new exercise searches
export const exerciseCircuitRef = (state = [], action = {}) => {
    let newState = [];
    switch (action.type) {
        case ACTIONS.EXERCISES_LOAD:
            if (
                action.exercises.length === rawExerciseCount &&
                state.length > 0
            ) {
                return state;
            }

            rawExerciseCount = action.exercises.length;
            for (let i = 0; i < action.exercises.length; i++) {
                const exercise = action.exercises[i];
                if (exercise.eType === 'wc' || exercise.eType === 'e') {
                    newState.push({
                        ...exercise,
                        value: exercise.id,
                        label: exercise.title
                    });
                }
            }

            newState.options = _.sortBy(newState, option => -option.use_count);
            return newState;
        case ACTIONS.EXERCISE_UPDATE:
            newState = [...state];
            const exeIndex = _.findKey(newState, { id: action.exercise.id });
            if (exeIndex) {
                newState[exeIndex] = action.exercise;
            }
            newState.options = [...newState];
            return newState;
        default:
            return state;
    }
};

export const schemeRef = (state = [], action = {}) => {
    let options = [];
    switch (action.type) {
        case ACTIONS.SCHEMES_LOAD:
            if (action.schemes.length === state.length) {
                return state;
            }
            options = _.sortBy(action.schemes, option => -option.use_count);
            return [...options];
        case ACTIONS.UPDATE_SCHEME_COUNT:
            options = _.sortBy(state, option => -option.use_count);
            return [...options];
        case ACTIONS.SCHEME_ADD:
            var val = action.scheme;
            val.isNew = true;
            return [...state, val];
        case ACTIONS.SCHEMES_TH_CLEAR:
            const allSchemes = [...state];
            const nonTHSchemes = allSchemes.filter(ex => ex.user_id);
            return nonTHSchemes;
        default:
            return state;
    }
};

export const sportRef = (state = [], action = {}) => {
    switch (action.type) {
        case ACTIONS.SPORTS_LOAD:
            if (action.sports.length === state.length) {
                return state;
            }
            return [...action.sports];
        default:
            return state;
    }
};

export const filterLibraryType = (state = {}, action = {}) => {
    switch (action.type) {
        case ACTIONS.FILTER_EXERCISES:
            var newState = {
                showTHExercises: action.enableTrainHeroicLibraryFilter
            };
            return newState;
        default:
            return state;
    }
};

export const paramTypeRef = (state = [], action = {}) => {
    switch (action.type) {
        case ACTIONS.PARAMTYPES_LOAD:
            if (action.paramTypes.length === state.length) {
                return state;
            }
            return action.paramTypes;
        default:
            return state;
    }
};

export const leaderboardTypesRef = (state = {}, action = {}) => {
    switch (action.type) {
        case ACTIONS.LEADERBOARDTYPES_LOAD:
            var newState = {
                lbTypes: [...action.leaderboardTypes],
                resultsTypes: [...action.leaderboardTypes]
            };
            newState.resultsTypes[0] = { id: 0, title: 'For Completion' };
            return newState;
        default:
            return state;
    }
};

export const subscriptionsTree = (state = {}, action = {}) => {
    let newState = {};
    let group = null;
    let item = null;
    switch (action.type) {
        case ACTIONS.LOAD_SUBSCRIPTIONS:
            newState = {
                ...action.subscriptions
            };
            return newState;
        case ACTIONS.LIBRARY_SUBSCRIPTION_ADD:
            newState = { ...state };
            group = action.isAthlete ? 'athletes' : 'teams';
            item = _.find(newState[group], { id: action.id });
            item.programSubs.push(parseInt(action.programId));
            return newState;
        case ACTIONS.LIBRARY_SUBSCRIPTION_REMOVE:
            newState = { ...state };
            group = action.isAthlete ? 'athletes' : 'teams';
            item = _.find(newState[group], { id: action.id });
            item.programSubs.splice(
                item.programSubs.indexOf(parseInt(action.programId)),
                1
            );
            return newState;
        default:
            return state;
    }
};

export const orgsTree = (state = [], action = {}) => {
    let newState = [];
    switch (action.type) {
        case ACTIONS.ORGS_LOAD:
            newState = [...action.orgs];
            return newState;
        default:
            return state;
    }
};

export const orgsHealthTree = (state = [], action = {}) => {
    let newState = [];
    switch (action.type) {
        case ACTIONS.ORGS_HEALTH_LOAD:
            newState = [...action.orgs];
            return newState;
        default:
            return state;
    }
};

export const teamsTree = (state = [], action = {}) => {
    switch (action.type) {
        case ACTIONS.TEAMS_LOAD:
            return action.teams;
        default:
            return state;
    }
};

export const athletesTree = (state = [], action = {}) => {
    switch (action.type) {
        case ACTIONS.ATHLETES_LOAD:
            return action.athletes;
        default:
            return state;
    }
};

export const invitedAthletesTree = (state = [], action = {}) => {
    switch (action.type) {
        case ACTIONS.INVITED_ATHLETES_LOAD:
            return action.invitedAthletes;
        default:
            return state;
    }
};

export default combineReducers({
    invitedAthletesTree,
    athletesTree,
    calendarProgramsTree,
    exerciseRef,
    exerciseBenchmarkRef,
    exerciseCircuitRef,
    fixedLengthProgramsTree,
    filterLibraryType,
    leaderboardTypesRef,
    librarySessionsTree,
    paramTypeRef,
    schemeRef,
    sportRef,
    subscriptionsTree,
    orgsTree,
    orgsHealthTree,
    teamsTree
});

// private methods
function calculateSubcount(subcount, base = null, plus) {
    let count = subcount || 0;
    if (plus) {
        return count + 1;
    }
    return count === 0 ? 0 : count <= base ? count : count - 1;
}



// WEBPACK FOOTER //
// ./src/state/reducer/library/reducer.js